module.exports = __webpack_public_path__ + "img/40_38_035_220.a3d8810f.jpg";